import { Role } from "@/core/auth/models/role.model";
import {
  ArrowUpWideNarrow,
  Building2,
  Car,
  Component,
  Handshake,
  HomeIcon,
  KeySquare,
  ListCheckIcon,
  ListChecks,
  ListOrdered,
  MessageCircleQuestionMark,
  ScanBarcode,
  Settings,
  ShoppingBag,
  Users,
} from "lucide-react";
import React from "react";

export interface NavItem {
  label: string;
  href: string;
  icon: React.ReactNode;
  iconDark: React.ReactNode;
  count: number;
  isAdmin?: boolean;
  roles?: string[];
}
export const defaultNavItems: NavItem[] = [
  {
    label: "Dashboard",
    href: "/app/dashboard",
    icon: <HomeIcon className="w-6 h-6" />,
    iconDark: <HomeIcon className="w-6 h-6" />,
    count: 0,
    roles: [Role.SuperAdmin, Role.CompanyAdmin, Role.Employee, Role.Customer],
  },
  // {
  //   label: "Queue",
  //   href: "/app/queue",
  //   icon: <ArrowUpWideNarrow className="w-6 h-6" />,
  //   iconDark: <ArrowUpWideNarrow className="w-6 h-6" />,
  //   count: 0,
  //   roles: [Role.SuperAdmin, Role.CompanyAdmin, Role.Employee, Role.Customer],
  // },
  {
    label: "POS",
    href: "/app/pos",
    icon: <ScanBarcode className="w-6 h-6" />,
    iconDark: <ScanBarcode className="w-6 h-6" />,
    count: 0,
    roles: [Role.CompanyAdmin, Role.Employee],
  },
  {
    label: "Orders",
    href: "/app/orders",
    icon: <ListOrdered className="w-6 h-6" />,
    iconDark: <ListOrdered className="w-6 h-6" />,
    count: 0,
    roles: [Role.SuperAdmin, Role.CompanyAdmin, Role.Employee, Role.Customer],
  },
  {
    label: "Employees",
    href: "/app/employees",
    icon: <Users className="w-6 h-6" />,
    iconDark: <Users className="w-6 h-6" />,
    roles: [Role.SuperAdmin, Role.CompanyAdmin, Role.Employee],
    count: 0,
  },
  {
    label: "Companies",
    href: "/app/companies",
    icon: <Building2 className="w-6 h-6" />,
    iconDark: <Building2 className="w-6 h-6" />,
    roles: [Role.SuperAdmin],
    count: 0,
  },
  // Transactions
  {
    label: "Transactions",
    href: "/app/transactions",
    icon: <ListCheckIcon className="w-6 h-6" />,
    iconDark: <ListCheckIcon className="w-6 h-6" />,
    count: 0,
    roles: [Role.SuperAdmin, Role.CompanyAdmin, Role.Employee],
  },
  {
    label: "Car Services",
    href: "/app/car-services",
    icon: <ShoppingBag className="w-6 h-6" />,
    iconDark: <ShoppingBag className="w-6 h-6" />,
    roles: [Role.SuperAdmin, Role.CompanyAdmin, Role.Employee, Role.Customer],
    count: 0,
  },
  {
    label: "Categories",
    href: "/app/categories",
    icon: <ListChecks className="w-6 h-6" />,
    iconDark: <ListChecks className="w-6 h-6" />,
    count: 0,
    roles: [Role.SuperAdmin],
  },
  // sub categories
  {
    label: "Sub Categories",
    href: "/app/sub-categories",
    icon: <Component className="w-6 h-6" />,
    iconDark: <Component className="w-6 h-6" />,
    count: 0,
    roles: [Role.SuperAdmin, Role.CompanyAdmin, Role.Employee, Role.Customer],
  },
  // {
  //   label: "Settings",
  //   href: "/app/settings",
  //   icon: <Settings className="w-6 h-6" />,
  //   iconDark: <Settings className="w-6 h-6" />,
  //   count: 0,
  //   roles: [Role.SuperAdmin, Role.CompanyAdmin, Role.Employee, Role.Customer],
  // },
  // {
  //   label: "Terms & Conditions",
  //   href: "/app/terms-conditions",
  //   icon: <HandCoins className="w-6 h-6" />,
  //   iconDark: <HandCoins className="w-6 h-6" />,
  //   count: 0,
  // },

  {
    label: "Users",
    href: "/app/users",
    icon: <Users className="w-6 h-6" />,
    iconDark: <Users className="w-6 h-6" />,
    count: 0,
    isAdmin: true,
    roles: [Role.SuperAdmin],
  },
  {
    label: "Support",
    href: "/app/support",
    icon: <MessageCircleQuestionMark className="w-6 h-6" />,
    iconDark: <MessageCircleQuestionMark className="w-6 h-6" />,
   
    count: 0,
    isAdmin: true,
    roles: [Role.SuperAdmin],
  },
  // {
  //   label: "Customers",
  //   href: "/app/customers",
  //   icon: <Handshake className="w-6 h-6" />,
  //   iconDark: <Handshake className="w-6 h-6" />,
  //   count: 0,
  //   roles: [Role.SuperAdmin, Role.CompanyAdmin, Role.Employee],
  // },
  // {
  //   label: "Pricing Plans",
  //   href: "/app/admin/pricing-plans",
  //   icon: <HandCoins className="w-6 h-6" />,
  //   iconDark: <HandCoins className="w-6 h-6" />,
  //   count: 0,
  //    isAdmin: true,
  // },
];
